"use client";

import { AudioWaveIcon } from "@/component/AudioWaveIcon";
import { useGlobalMediaPlayer } from "@/hooks/useGlobalMediaPlayer";
import { useRef } from "react";

export function AudioSimplePlayer(props: { src: string }) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const { isPlaying, toggle, renderGlobalAudio } =
    useGlobalMediaPlayer(audioRef);

  return (
    <div
      className={`bg-background-elevated overflow-hidden relative w-full h-full flex items-center justify-center rounded-lg cursor-pointer`}
      onClick={toggle}
    >
      <AudioWaveIcon isPlaying={isPlaying} size={36} />
      {renderGlobalAudio({ src: props.src, style: { display: "none" } })}
    </div>
  );
}
